// extracted by mini-css-extract-plugin
export default {"container":"BenefactorOrders_container__MbT1d","header":"BenefactorOrders_header__oJxqU","content":"BenefactorOrders_content__rtrku"};